import { Outlet } from "react-router-dom";

export default function LicensesLayout() {
    return (
        <Outlet />
    )
}